<app-header
  [sub_titulo]="
    EsEdicion
      ? 'Administrador formulario - Editando asistente'
      : 'Administrador formulario - Nuevo asistente'
  "
></app-header>
<!-- Panel izquierda -->
<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
  <div id="menus" style="min-height: 95vh; height: auto">
    <div
      class="card-body-content"
      style="width: 99%; min-height: 90%; max-height: 99%; height: 90%"
    >
      <br />
      <mat-card style="height: 99%">
        <div class="nuevo-asistente-container">
          <div class="form-group">
            <app-campo-default-admin
              descripcion_etiqueta="Código (*)"
              placeholder_input=""
              [(ngModel)]="codigo"
            >
            </app-campo-default-admin>
          </div>

          <div class="form-group">
            <app-campo-default-admin
              descripcion_etiqueta="Nombre (*)"
              placeholder_input=""
              [(ngModel)]="nombre"
            >
            </app-campo-default-admin>
          </div>

          <div class="form-field-align" *ngIf="this.EsEdicion">
            <label for="habilitado">Habilitado (*)</label>
            <mat-slide-toggle [(ngModel)]="habilitado"></mat-slide-toggle>
          </div>

          <div class="form-field-align">
            <label for="habilitado">Requiere autenticación (*)</label>
            <mat-slide-toggle
              [(ngModel)]="requiereAutenticacion"
            ></mat-slide-toggle>
          </div>

          <div class="form-group" *ngIf="esUsuarioAdminitrador">
            <app-campo-default-admin
              id="areaFuncional"
              name="areaFuncional"
              descripcion_etiqueta="Área Funcional (*)"
              placeholder_input=""
              [(ngModel)]="areaFuncional"
            >
            </app-campo-default-admin>
          </div>

          <div class="form-group" *ngIf="!esUsuarioAdminitrador">
            <app-generic-select
              [options]="myOptionsAreasFunciones"
              placeholder="Área Funcional (*)"
              [(ngModel)]="areaFuncional"
            >
            </app-generic-select>
          </div>

          <div class="form-group">
            <app-generic-select
              [options]="myOptions"
              placeholder="Tipo formulario (*)"
              (selectionChange)="onSelected($event)"
              [(ngModel)]="tipoFormulario"
            >
            </app-generic-select>
          </div>

          <div class="form-group">
            <app-campo-default-admin
              descripcion_etiqueta="Tema (*)"
              placeholder_input=""
              [(model_value)]="tema"
              [(ngModel)]="tema"
            >
            </app-campo-default-admin>
          </div>

          <div class="form-group">
            <app-generic-select
              [options]="myOptionsDestinatario"
              placeholder="Destinatario"
              (selectionChange)="onSelectedDestinatario($event)"
              [(ngModel)]="destinatario"
            >
            </app-generic-select>
          </div>
          <app-mensaje-error
            *ngIf="error"
            [mensaje_error]="error"
          ></app-mensaje-error>
          <div class="fin">
            <app-boton-primario
              [disabled]="loading"
              [spinner]="loading"
              [boton_texto]="loading ? 'Guardando' : 'Guardar'"
              (boton_funcion)="applyOperation()"
              titulo="Guardar asistente formulario"
            ></app-boton-primario>
            <button mat-raised-button 
              (click)="volver()">Cancelar</button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</mat-card>
